import { useTranslation } from 'next-i18next';

import { Slider } from '@phoenix/design-system/frontend/ui/slider/slider';
import { useBreakpoints } from '@phoenix/design-system/frontend/ui/breakpoints/use-breakpoints';

import { OverviewSubsection } from '@phoenix/team-m/dashboard/frontend/ui/overview/overview-subsection';
import { ProductRecommendedCard } from '@phoenix/team-m/dashboard/frontend/ui/from-the-shop/product-recommendation/product-recommended-card';

import { RecommendedProduct } from './use-recommended-products';

export const PRODUCT_PAGE_SIZE = 4;

export const RecommendedProducts = ({ products }: { products: RecommendedProduct[] }) => {
  const { t } = useTranslation();
  const { desktop, tabletOnly } = useBreakpoints();

  const getSlidesPerView = () => {
    if (desktop) {
      return PRODUCT_PAGE_SIZE;
    }
    if (tabletOnly) {
      return 3.2;
    }
    return 1.4;
  };

  return (
    <OverviewSubsection headline={t('dashboard_fromTheShop_NBO_headline')} dataTestId="recommended-products">
      <Slider
        id="recommended-products"
        className="mt-6"
        sliderOptions={{
          spaceBetween: 24,
          slidesPerView: getSlidesPerView(),
          slidesPerGroup: desktop ? PRODUCT_PAGE_SIZE : 1,
        }}
        touchStartPreventDefault={false}
      >
        {products.map((product, i) => (
          <ProductRecommendedCard key={product.articleNumber} {...product} index={i + 1} />
        ))}
      </Slider>
    </OverviewSubsection>
  );
};
